import React, { useRef, useEffect, useCallback, useState} from 'react';
import {
    setQuickAddSearchText
} from 'actions/index.js';
import {useSearcher} from "components/sidebar/useSearcher.js";
import {connect} from 'react-redux';

const SidebarSearch = ({
    sequencerEngine,
    searchText,
    setSearchText
}) => { 
    let ref =  useRef(undefined);
    const [selectedTag, setSelectedTag] = useState(undefined);
    const [selectedEffect, setSelectedEffect] = useState(undefined);
    const [tags, setTags] = useState([]);
    const [effects, setEffects] = useState({});
    const {onChange, clear} = useSearcher({
        setTags,
        setEffects,
        tags,
        effects,
        sequencerEngine: sequencerEngine,
        searchText: searchText,
        setSearchText: setSearchText,
        selectedTag,
        setSelectedTag,
        selectedEffect,
        setSelectedEffect,
        ref
    });

    return (
        <div className="sample-search-container">
          <input value={searchText} onChange={onChange} placeholder="Search for sounds" ref={ref}/>
          <div onClick={clear} className="clear-btn">x</div>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      searchText: state.selector.quickAddSearchText,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setSearchText: x => dispatch(setQuickAddSearchText(x)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SidebarSearch);
